import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppIcon } from '../components/AppIcon';
export function SplashScreen() {
  const navigate = useNavigate();
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/intro');
    }, 2500);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="min-h-screen w-full bg-white flex flex-col items-center justify-center animate-fadeInUp" data-id="element-2186">
      <AppIcon size={420} className="w-[320px] h-[320px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px]" data-id="element-2187" />
      <p className="font-sans text-[18px] font-medium text-primary italic -mt-2 sm:-mt-4 text-center px-6" data-id="element-2188">
        Every breath counts
      </p>
    </div>;
}